"use client";

import LandingPageLayout from "@/components/layout/LandingPageLayout";
import { POLICY } from "@/utils/constants";

const Page = () => {
  return (
    <LandingPageLayout>
      <main className="lg:p-20 lg:pb-0 md:pb-0 pb-0 md:p-12 p-6 flex flex-col items-center w-full">
        <p className="text-sm">Legal</p>
        <h2 className="text-primary font-semibold md:text-3xl text-2xl">
          Privacy Policy
        </h2>
        <p className="text-xs">Last Updated: November 1st, 2024</p>
        <div className="space-y-6 mt-8">
          {POLICY.map(({ title, description }, index) => {
            return (
              <div key={index}>
                <div className="flex font-semibold">
                  <span>{index + 1}. </span>
                  <h2>{title}</h2>
                </div>
                <p className="text-sm">{description}</p>
              </div>
            );
          })}
        </div>
      </main>
    </LandingPageLayout>
  );
};

export default Page;
